import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMyDiscovery } from '@/actions/my-discovery/createMyDiscovery';
import { DiscoveryStatus } from '@/types/discovery.status.type';
import { ApiResponse } from '@/types/response.type';

export interface UseCreateMyDiscoveryReturn {
  mutate: (
    payload: DiscoveryStatus
  ) => Promise<ApiResponse<DiscoveryStatus> | undefined>;
  result: ApiResponse<DiscoveryStatus> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateMyDiscovery = (): UseCreateMyDiscoveryReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    ApiResponse<DiscoveryStatus> | undefined,
    Error,
    DiscoveryStatus
  >({
    mutationFn: createMyDiscovery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['my-discovery'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
